import { render, staticRenderFns } from "./DeprovisionDialog.vue?vue&type=template&id=a9036636&scoped=true&"
import script from "./DeprovisionDialog.vue?vue&type=script&lang=js&"
export * from "./DeprovisionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9036636",
  null
  
)

export default component.exports